import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";
import BannerImg from "../assets/Images/banner2-1920x450.png";
import BottomLogoImg from "../assets/Images/bottom-logo.png";
import PDF from "../assets/Images/pdf.png";
import PDFDownload from "../assets/Images/pdfdownload.png";
import MainImg from "../assets/Images/mediation.png";
import TitleImg from "../assets/Images/title.png";
import ImageTextLayout from "../shared/ImageTextLayout";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./MPMHKPage.scss";

const MPMHKPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title">
          <h1 className="banner-main-title">{t("practice_manual_page_header")}</h1>
          <p className="banner-subtitle">{t("practice_manual_page_header2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_practice_manual_page_link1")}</Link>
        <span>{t("breadcrumbs_practice_manual_page_span")}</span>
        <Link>{t("breadcrumbs_practice_manual_page_link2")}</Link>
      </Breadcrumbs>
      <ImageTextLayout
        image={MainImg}
        imageAlt="Mediation Practice Manual"
        titleIcon={TitleImg}
        title={t("practice_manual_page_h3")}
        className="mpmhk-layout"
      >
        <p>{t("practice_manual_page_text1")}</p>
        <p>{t("practice_manual_page_text2")}</p>
        <p>{t("practice_manual_page_text3")}</p>
        <p>{t("practice_manual_page_text4")}</p>
        <p>{t("practice_manual_page_text5")}</p>
        <p>
          {t("practice_manual_page_text6")}
          <a className="mpmhk-form-link" href="https://forms.gle/nQYTUECAdBEv1Nrs7">
            {t("practice_manual_page_text7a")}
          </a>
          {t("practice_manual_page_text7")}
        </p>
        <div className="mpmhk-download-section">
          <div className="mpmhk-pdf-info">
            <img src={PDF} alt="" className="mpmhk-pdf-icon" />
            <span>(PDF)</span>
          </div>
          <a href="https://www.hkarbsoc.org.hk/medPracInHK.pdf" className="mpmhk-download-link">
            <img src={PDFDownload} alt="Download PDF" className="mpmhk-download-icon" />
          </a>
        </div>
      </ImageTextLayout>
      <div className="temporary">
        <img src={BottomLogoImg} alt="" />
      </div>

      <Footer />
    </>
  );
};

export default MPMHKPage;
